import { render } from "./TanaoroshiSkuListPage.vue?vue&type=template&id=35de57dc"
import script from "./TanaoroshiSkuListPage.vue?vue&type=script&lang=js"
export * from "./TanaoroshiSkuListPage.vue?vue&type=script&lang=js"

import exportComponent from "/w/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__